export default class HeroImageModel {
  constructor(public src?: string, public alt?: string) {}
}
